module.exports = __webpack_public_path__ + "img/frances-willard.1cf62c38.png";